import type { HTMLAttributes } from 'react'
import { ThemeImage, type ThemeImageSource } from './ThemeImage'

export type DeviceKind = 'iphone' | 'android'

type DeviceFrameProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  source: ThemeImageSource
  alt: string
  device?: DeviceKind
  loading?: 'eager' | 'lazy'
}

export function DeviceFrame({ source, alt, device = 'iphone', loading = 'eager', className, ...props }: DeviceFrameProps) {
  return (
    <div className={`device-frame device-frame-${device}${className ? ` ${className}` : ''}`} data-device={device} {...props}>
      <div className="device-frame__screen">
        <ThemeImage source={source} alt={alt} loading={loading} />
      </div>
    </div>
  )
}
